import React from "react"

import { Divider } from "../../components/shared/Layout"
import Typography from "../../components/shared/Typography"
import { ToastProvider } from "../../contexts/ToastContext"
import GraphQLProvider from "../../providers/GraphQLProvider"

import BuilderVersionSettings from "./BuilderVersionSettings"
import CustomScriptsSettings from "./CustomScriptsSettings"
import SeoSettings from "./SeoSettings"
import WebsiteDomain from "./WebsiteDomain"

const WebsiteSettingsComponent = ({ customDomain, website, websiteMetadata, practice }) => (
  <>
    <div>
      <div className="mb-9 flex flex-col sm:mb-4">
        <Typography as="h1" variant="h3">
          Website Settings
        </Typography>
      </div>
    </div>
    <WebsiteDomain customDomain={customDomain} website={website} />

    <>
      <Divider className="my-10" />
      <BuilderVersionSettings practice={practice} />
    </>

    <>
      <Divider className="my-10" />
      <SeoSettings websiteMetadata={websiteMetadata} />
    </>

    <>
      <Divider className="my-10" />
      <CustomScriptsSettings practice={practice} />
    </>
  </>
)

export default function WebsiteSettings({ ...props }) {
  return (
    <ToastProvider>
      <GraphQLProvider>
        <WebsiteSettingsComponent {...props} />
      </GraphQLProvider>
    </ToastProvider>
  )
}
